"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AngleRegistry__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ICoreBorrow",
                name: "_coreBorrow",
                type: "address",
            },
            {
                internalType: "contract IMarketplace",
                name: "_marketplace",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "NotGovernorOrGuardian",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddress",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "marketId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "quoteToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "baseToken",
                type: "address",
            },
        ],
        name: "RegistryEntrySet",
        type: "event",
    },
    {
        inputs: [],
        name: "coreBorrow",
        outputs: [
            {
                internalType: "contract ICoreBorrow",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "quoteToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "baseToken",
                type: "address",
            },
        ],
        name: "getMarketId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "marketplace",
        outputs: [
            {
                internalType: "contract IMarketplace",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "registry",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "marketId",
                type: "bytes32",
            },
        ],
        name: "setRegistryEntry",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class AngleRegistry__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AngleRegistry__factory = AngleRegistry__factory;
AngleRegistry__factory.abi = _abi;
//# sourceMappingURL=AngleRegistry__factory.js.map